import React from 'react';
import styles from './ArtistSuggestionsItemEditorFooter.module.css';
import {Divider} from "@mui/material";
import BaseSimpleItemEditorFooterButton from "../BaseSimplePage/BaseSimpleItemEditorFooterButton";

const ArtistSuggestionsItemEditorFooter = ({step, onDeleteSuggestionBtnClick, onAcceptSuggestionBtnClick,
                                             onLinkSuggestionBtnClick, onNextBtnClick, onPrevBtnClick}) => {
    return (
        <div className={styles.main}>
            <Divider component="div"/>
            <div className={styles.buttonsArea}>
                {step === 1 && <>
                    {<BaseSimpleItemEditorFooterButton
                        label="Назад"
                        onClick={onPrevBtnClick}
                        disabled={true}
                    />}
                    {<BaseSimpleItemEditorFooterButton
                        label="Удалить заявку"
                        onClick={onDeleteSuggestionBtnClick}
                    />}
                    {<BaseSimpleItemEditorFooterButton
                        label="Далее"
                        onClick={onNextBtnClick}
                    />}
                </>}
                {step === 2 && <>
                    {<BaseSimpleItemEditorFooterButton
                        label="Назад"
                        onClick={onPrevBtnClick}
                    />}
                    {<BaseSimpleItemEditorFooterButton
                        label="Связать заявку"
                        onClick={onLinkSuggestionBtnClick}
                    />}
                    {<BaseSimpleItemEditorFooterButton
                        label="Далее"
                        onClick={onNextBtnClick}
                    />}
                </>}
                {step === 3 && <>
                    {<BaseSimpleItemEditorFooterButton
                        label="Назад"
                        onClick={onPrevBtnClick}
                    />}
                    {<BaseSimpleItemEditorFooterButton
                        label="Добавить автора"
                        onClick={onAcceptSuggestionBtnClick}
                    />}
                    {<BaseSimpleItemEditorFooterButton
                        label="Удалить"
                        onClick={onDeleteSuggestionBtnClick}
                    />}
                    {<BaseSimpleItemEditorFooterButton
                        label="Далее"
                        onClick={onNextBtnClick}
                        disabled={true}
                    />}
                </>}
            </div>
        </div>
    );
};

export default ArtistSuggestionsItemEditorFooter;